/* maks-rzad: skrypty sekcji przeniesione z pliku sekcji. Uruchamiaja wszystkie
   kopie sekcji na stronie. */
;var RZ_SEKCJA = function (SID, REVEAL) {
    var VT_OK = !!(window.CSS && CSS.supports && CSS.supports('view-transition-name', 'x'));
    var VT_NAME = 'sz-prod';
    var VT_HELD = null;

    function slowOff() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function vtScan() {
        if (VT_HELD) return VT_HELD;
        VT_HELD = [];
        if (!VT_OK) return VT_HELD;
        var c = document.querySelectorAll('img, picture, video, svg');
        for (var i = 0; i < c.length; i++) {
            var el = c[i];
            for (var d = 0; d < 2 && el && el.style; d++) {
                if (VT_HELD.indexOf(el) < 0) {
                    var v = '';
                    try { v = window.getComputedStyle(el).getPropertyValue('view-transition-name') || ''; } catch (err) { v = ''; }
                    if (v.replace(/\s/g, '') === VT_NAME) { VT_HELD.push(el); }
                }
                el = el.parentElement;
            }
        }
        return VT_HELD;
    }
    function vtClear() {
        if (!VT_OK) return;
        var n = document.querySelectorAll('[data-sz-vt]');
        for (var i = 0; i < n.length; i++) {
            n[i].style.removeProperty('view-transition-name');
            n[i].removeAttribute('data-sz-vt');
        }
    }
    function vtMark(e) {
        if (!VT_OK || slowOff()) return;
        var t = e.target;
        if (!t || !t.closest) return;
        var card = t.closest('a.rz-card');
        if (!card) return;
        var img = card.querySelector('.rz-img');
        if (!img) return;
        vtClear();
        var held = vtScan();
        for (var i = 0; i < held.length; i++) {
            if (held[i] === img) continue;
            held[i].style.setProperty('view-transition-name', 'none');
            held[i].setAttribute('data-sz-vt', '0');
        }
        img.style.setProperty('view-transition-name', VT_NAME);
        img.setAttribute('data-sz-vt', '1');
    }

    var NATIVE = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()'));

    function reveal(g) {
        if (!REVEAL) return;
        if (!('IntersectionObserver' in window)) return;
        if (slowOff()) return;
        if (NATIVE && window.matchMedia && window.matchMedia('(min-width:768px)').matches) return;
        g.classList.add('is-reveal');
        var io = new IntersectionObserver(function (rec) {
            for (var i = 0; i < rec.length; i++) {
                if (!rec[i].isIntersecting) continue;
                io.disconnect();
                g.classList.add('is-in');
                setTimeout(function () { g.classList.remove('is-in'); g.classList.remove('is-reveal'); }, 1400);
                return;
            }
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        io.observe(g);
    }

    function boot() {
        var s = document.getElementById(SID);
        if (!s) return;
        var g = s.querySelector('.rz-grid');
        if (!g) return;
        if (g.getAttribute('data-rz-on') === '1') return;
        g.setAttribute('data-rz-on', '1');
        if (VT_OK) {
            g.addEventListener('pointerdown', vtMark, true);
            g.addEventListener('click', vtMark, true);
            if (window.requestIdleCallback) { window.requestIdleCallback(function () { vtScan(); }); } else { setTimeout(vtScan, 1200); }
        }
        reveal(g);
    }

    if (VT_OK) { window.addEventListener('pageshow', vtClear); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
};
/* kazda kopia sekcji dostaje wlasna instancje, jak wczesniej osobny skrypt w sekcji */
(function () {
    var start = function (scope) {
        var n = (scope || document).querySelectorAll('[data-rzv-root]');
        for (var i = 0; i < n.length; i++) {
            if (n[i].getAttribute('data-rz-init') === '1') continue;
            n[i].setAttribute('data-rz-init', '1');
            RZ_SEKCJA(n[i].id, n[i].getAttribute('data-rz-reveal') === '1');
        }
    };
    start(document);
    document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
;(function () {
  var start = function (root) {
    if (root.getAttribute('data-rz-on') === '1') return;
    root.setAttribute('data-rz-on', '1');
    var rail = root.querySelector('.rz-grid');
    if (!rail) return;
    var prev = root.querySelector('[data-rz-prev]');
    var next = root.querySelector('[data-rz-next]');
    var petla = root.getAttribute('data-rz-loop') === '1';
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var polowa = 0;
    var jedzie = false;
    var rafId = null;
    var wartownik = null;

    var klonuj = function () {
      if (!petla || rail.getAttribute('data-klon') === '1') return;
      if (rail.scrollWidth <= rail.clientWidth + 4) return;
      var org = [].slice.call(rail.children);
      if (!org.length) return;
      rail.setAttribute('data-klon', '1');
      // klony nie moga odziedziczyc stanu ukrycia z animacji wjazdu
      rail.classList.remove('is-reveal');
      rail.classList.add('is-in');
      for (var i = 0; i < org.length; i++) {
        var k = org[i].cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('tabindex', '-1');
        k.removeAttribute('id');
        rail.appendChild(k);
      }
    };

    var mierz = function () {
      polowa = rail.getAttribute('data-klon') === '1' ? rail.scrollWidth / 2 : 0;
    };

    var pilnuj = function () {
      if (!polowa) return;
      if (rail.scrollLeft >= polowa) rail.scrollLeft -= polowa;
    };

    var przerwij = function () {
      if (rafId) { window.cancelAnimationFrame(rafId); rafId = null; }
      if (wartownik) { window.clearTimeout(wartownik); wartownik = null; }
      jedzie = false;
    };

    var anim = function (cel) {
      przerwij();
      if (calm.matches) { rail.scrollLeft = cel; pilnuj(); return; }
      var od = rail.scrollLeft;
      var dyst = cel - od;
      if (!dyst) return;
      var t0 = null;
      var czas = 620;
      jedzie = true;
      wartownik = window.setTimeout(function () { przerwij(); pilnuj(); }, czas + 200);
      var krok = function (ts) {
        if (t0 === null) t0 = ts;
        var pr = (ts - t0) / czas;
        if (pr > 1) pr = 1;
        var e = pr === 1 ? 1 : 1 - Math.pow(2, -10 * pr);
        rail.scrollLeft = od + dyst * e;
        if (pr < 1) { rafId = window.requestAnimationFrame(krok); }
        else { przerwij(); pilnuj(); }
      };
      rafId = window.requestAnimationFrame(krok);
    };

    var poz = function (el) {
      return el.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
    };

    var przyciagnij = function (x, pad) {
      var d = rail.children;
      var best = 0;
      for (var i = 0; i < d.length; i++) {
        var pp = poz(d[i]) - pad;
        if (pp <= x + 1) { best = pp; } else { break; }
      }
      return best;
    };

    var idz = function (kier) {
      mierz();
      var d = rail.children;
      if (!d.length) return;
      var wid = rail.clientWidth;
      if (!wid) return;
      var lewa = rail.scrollLeft;
      var pad = parseFloat(window.getComputedStyle(rail).paddingLeft) || 0;
      var cel = null;
      if (kier > 0) {
        for (var i = 0; i < d.length; i++) {
          var pp = poz(d[i]);
          if (pp + d[i].offsetWidth > lewa + wid + 1) { cel = pp - pad; break; }
        }
        if (cel === null) { cel = lewa + wid; }
      } else {
        cel = przyciagnij(lewa - wid + pad, pad);
        if (cel >= lewa - 1) { cel = lewa - wid; }
      }
      if (cel < 0) {
        if (polowa) { rail.scrollLeft += polowa; cel += polowa; }
        else { cel = 0; }
      }
      anim(cel);
    };

    if (prev) prev.addEventListener('click', function () { idz(-1); });
    if (next) next.addEventListener('click', function () { idz(1); });
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (zd) {
      rail.addEventListener(zd, przerwij, { passive: true });
    });
    rail.addEventListener('scroll', function () { if (!jedzie) pilnuj(); }, { passive: true });

    var odswiez = function () { klonuj(); mierz(); };
    odswiez();
    if (window.ResizeObserver) { new ResizeObserver(odswiez).observe(rail); }
    else { window.addEventListener('resize', odswiez); }
    window.setTimeout(odswiez, 600);
  };

  /* Karuzele ponizej pierwszego ekranu uruchamiamy dopiero, gdy przewijanie
     zbliza sie do nich (800 px zapasu), zamiast wszystkich naraz przy wczytaniu
     strony. Te widoczne od razu startuja tak jak wczesniej. */
  var wkrotce = function (el, fn) {
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { fn(el); return; }
    if (el.getBoundingClientRect().top < (window.innerHeight || 800) * 1.5) { fn(el); return; }
    var io = new IntersectionObserver(function (wpisy) {
      for (var j = 0; j < wpisy.length; j++) {
        if (wpisy[j].isIntersecting) { io.disconnect(); fn(el); return; }
      }
    }, { rootMargin: '800px 0px' });
    io.observe(el);
  };
  var boot = function (scope) {
    var n = (scope || document).querySelectorAll('[data-rz-car]');
    for (var i = 0; i < n.length; i++) wkrotce(n[i], start);
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(document); }); }
  else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
}());
